import React from 'react';
import { AuthContext } from "../hooks/auth/AuthContext";
import Login from '../pages/auth/Login'
import {Route, Routes   } from 'react-router-dom';
import Home from '../pages/Home'
import TenantsPage from '../pages/Configuracion/TenantsPage';
import UsuariosPage from '../pages/Configuracion/UsuariosPage';
import EstablecimientosPage from '../pages/Configuracion/EstablecimientosPage';
import PuntosExpedicionPage from '../pages/Configuracion/PuntosExpedicionPage';
import CertificadosPage from '../pages/Configuracion/CertificadosPage';
import TimbradosPage from '../pages/Configuracion/TimbradosPage';
import ConsultaRucPage from '../pages/Configuracion/ConsultaRucPage';
import { useContext } from "react";

const Pages = () => {
    const authContext = useContext(AuthContext);
    const {user} = authContext;
    
    const userHasRole = (requiredRoles) => {
      if (!user || !user.roles) {
        return false;
      }
    
      // Convertir user.roles a array si no lo es
      const userRolesArray = Array.isArray(user.roles) ? user.roles : [user.roles];
      
      // Convertir requiredRoles a array si no lo es
      const requiredRolesArray = Array.isArray(requiredRoles) ? requiredRoles : [requiredRoles];
      
      // Verificar si alguno de los roles del usuario está en los roles requeridos
      return requiredRolesArray.some(role => userRolesArray.includes(role));
    };

    const isOwner = () => {
      if (!user || !user.roles) {
        return false;
      }
      return user.roles === "Owner" || (Array.isArray(user.roles) && user.roles.includes("Owner"));
    };
    
    const isAdmin = () => {
      if (!user || !user.roles) {
        return false;
      }
      return user.roles === "Administrador" || (Array.isArray(user.roles) && user.roles.includes("Administrador"));
    };

    return (
        <Routes>
          
          {/* Rutas Protegidas */}
          {userHasRole(["Administrador", "user"]) && (
            <Route path="/home" element={<Home/>} />
          )}

          {/* Rutas solo para Owner - Gestión de Plataforma */}
          {isOwner() && (
            <>
              <Route path="/configuracion/tenants" element={<TenantsPage/>} />
            </>
          )}
          
          {/* Rutas para Owner y Administrador - Usuarios */}
          {(isOwner() || isAdmin()) && (
            <>
              <Route path="/configuracion/usuarios" element={<UsuariosPage/>} />
            </>
          )}
          
          {/* Rutas solo para Administrador - Configuraciones de Tenant */}
          {isAdmin() && (
            <>
              <Route path="/configuracion/establecimientos" element={<EstablecimientosPage/>} />
              <Route path="/configuracion/puntos-expedicion" element={<PuntosExpedicionPage/>} />
              <Route path="/configuracion/timbrados" element={<TimbradosPage/>} />
              <Route path="/configuracion/certificados" element={<CertificadosPage/>} />
              <Route path="/configuracion/consulta-ruc" element={<ConsultaRucPage/>} />
            </>
          )}

          {user ? <Route path="*" element={<Home />} /> : 
          <>
            <Route path="/auth-login" element={<Login />} />
            <Route path="*" element={<Login />} />
          </>}
        </Routes>
    );
};

export default Pages;
